const normalize = (s) =>
  (s || "")
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9 ]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const levenshtein = (a, b) => {
  const m = a.length;
  const n = b.length;
  if (!m) return n;
  if (!n) return m;
  let prev = new Array(n + 1);
  for (let j = 0; j <= n; j++) prev[j] = j;
  for (let i = 1; i <= m; i++) {
    const cur = [i];
    for (let j = 1; j <= n; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
    }
    prev = cur;
  }
  return prev[n];
};

const similarity = (a, b) => {
  const max = Math.max(a.length, b.length);
  if (!max) return 0;
  return 1 - levenshtein(a, b) / max;
};

const windowSimilarity = (a, b) => {
  const aw = a.split(" ");
  const bw = b.split(" ");
  const [shortW, longW] = aw.length <= bw.length ? [aw, bw] : [bw, aw];
  if (shortW.length === longW.length) return similarity(a, b);
  const needle = shortW.join(" ");
  let best = 0;
  for (let i = 0; i + shortW.length <= longW.length; i++) {
    best = Math.max(
      best,
      similarity(needle, longW.slice(i, i + shortW.length).join(" ")),
    );
  }
  return best;
};

export const MATCH_THRESHOLD = 0.6;

export const matchSpoken = (text, options, labelOf) => {
  const hay = normalize(text);
  const cands = [];
  for (const opt of options) {
    const label = normalize(labelOf(opt));
    if (!label) continue;
    const start = hay.indexOf(label);
    if (start === -1) continue;
    cands.push({ opt, start, end: start + label.length, len: label.length });
  }
  cands.sort((a, b) => b.len - a.len || a.start - b.start);
  const accepted = [];
  for (const c of cands) {
    if (accepted.some((a) => c.start < a.end && a.start < c.end)) continue;
    accepted.push(c);
  }
  return accepted.sort((a, b) => a.start - b.start).map((c) => c.opt);
};

export const findClosestOption = (text, options, labelOf) => {
  const spoken = normalize(text);
  if (!spoken) return null;
  let best = null;
  for (const opt of options) {
    const label = normalize(labelOf(opt));
    if (!label) continue;
    const score = windowSimilarity(label, spoken);
    if (!best || score > best.score) best = { option: opt, score };
  }
  return best && best.score >= MATCH_THRESHOLD ? best : null;
};
